import { Link } from "react-router-dom";
import { faqs } from "@/mocks/faqs";

export default function FAQ() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12">
            <p className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-2">
              Frequently Asked
            </p>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">
              Kakobuy Spreadsheet FAQ
            </h2>
          </div>

          <div className="space-y-3">
            {faqs.map((faq, idx) => (
              <details key={idx} className="group bg-background-100 rounded-xl border border-background-200/70 overflow-hidden">
                <summary className="flex items-center justify-between px-6 py-4 cursor-pointer hover:bg-background-50 transition-colors list-none">
                  <span className="text-sm md:text-base font-medium text-foreground-800 pr-4">
                    {faq.question}
                  </span>
                  <span className="w-6 h-6 flex items-center justify-center flex-shrink-0 text-foreground-400 group-open:hidden">
                    <i className="ri-add-line"></i>
                  </span>
                  <span className="w-6 h-6 items-center justify-center flex-shrink-0 text-foreground-400 hidden group-open:flex">
                    <i className="ri-subtract-line"></i>
                  </span>
                </summary>
                <div className="px-6 pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </details>
            ))}
          </div>

          {/* Internal Link to Guide */}
          <div className="text-center mt-10">
            <Link
              to="/guide/how-to-use-kakobuy-spreadsheet"
              className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors"
            >
              Read the Complete Kakobuy Spreadsheet Guide
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>

      {/* FAQ Schema - Structured Data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": faqs.map((faq) => ({
              "@type": "Question",
              "name": faq.question,
              "acceptedAnswer": {
                "@type": "Answer",
                "text": faq.answer,
              },
            })),
          }),
        }}
      />
    </section>
  );
}